import * as React from "react";

interface PropsTyC {
    tyc: any;
    check: () => any;
}

export const TyCComponent:React.FC<PropsTyC> = ({tyc, check}) => {
    const [disbaleBtn, setDisbaleBtn] = React.useState<boolean>(false);
    React.useEffect(() => {
        if(tyc && tyc.check_tc) {
            setDisbaleBtn(true);
        }
    }, [tyc]);

    return (
        <div className="container container-fluid d-flex justify-content-center" style={{
            position: 'absolute', 
            bottom: '0', 
            top: '0', 
            alignItems: 'center', 
            flexDirection: 'column'}}>
           <div className="row w-100">
                <div className="card w-100 m-3 justify-content-center align-items-center">
                {tyc.check_tc ? (
                    <>
                        <div className='p-3'>
                            {tyc.url ? <a href={tyc.url} target='_blank'><p>{tyc.message}</p></a> : <p>{tyc.message}</p> }
                        </div>
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" onChange={(e) => setDisbaleBtn(!e.target.checked)}/>
                            <label>Acepto Términos y Condiciones</label>
                        </div>
                        
                    </>
                ): <>
                        <div className='p-3'>
                        {tyc.url ? <a href={tyc.url} target='_blank'><p>{tyc.message}</p></a> : <p>{tyc.message}</p> }
                        </div>                        
                    </>
                }
                <div>
                   
                </div>
                </div>
           </div>
           <div className="row">
                <button className="btn btn-primary" disabled={disbaleBtn} onClick={() => check()}>{tyc.label_btn ? tyc.label_btn : 'Continuar'}</button>
           </div>
           
        </div>
    );
}